import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import {
  BtnsWrapper,
  CloseButton,
  ErrorMessage,
  SavePanel,
} from './BackModal.styles';
import Close from 'Icons/Close';
import Title from 'components/Typography/Title';
import Button from 'components/Button';
import { useTranslation } from 'react-i18next';

function BackModal({
  handleSave,
  handleCancel,
  isOpen,
  closeModal,
  name,
  status,
}) {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} closeModal={closeModal}>
      <SavePanel>
        <CloseButton variant="roundedWhite" onClick={closeModal}>
          <Close />
        </CloseButton>
        <Title level="label" size="lg">
          {t('confirmLeavingEdit')}
        </Title>
        <BtnsWrapper>
          <Button
            onClick={() => handleSave(name)}
            variant="primary"
            size="small"
          >
            {t('save')}
          </Button>
          <Button onClick={handleCancel} variant="secondary" size="small">
            {t('cancel')}
          </Button>
        </BtnsWrapper>
        {status === 'error' && <ErrorMessage>{t('nameExist')}</ErrorMessage>}
      </SavePanel>
    </Modal>
  );
}

BackModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default BackModal;
